import React from 'react';
import HomeModule from '../modules/HomeModule';
import { withRouter } from 'react-router-dom';
import ScrollToTop from '../components/ScrollToTop';

function HomePage({ history }) {
    return (
        <div
            className="u-pb-small u-rema-full-height"
            data-testid="homePageTestId"
        >
            <ScrollToTop></ScrollToTop>
            <HomeModule history={history}></HomeModule>
        </div>
    );
}

export default withRouter(HomePage);
